import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { COUNTRY_CODE_FOR_SLOVAKIA, COUNTRY_CODE_FOR_UKRAINE } from '@/config';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    countries: [],
    cities: [],
    streets: [],
    contactPlaces: [],
    attachments: [],
    eTransactionCreated: false,
    eSignatureAttempts: 0,
    eIDAttempts: 1,
    appConfiguration: {
      showESign: false,
      showEID: false,
      showESignWithID: false,

      establishmentTurnOffCourier: 'false',
      changeTurnOffCourier: 'false',

      establishmentTurnOffPost: 'false',
      changeTurnOffPost: 'false',

      establishmentTurnOffContactPlace: 'false',
      changeTurnOffContactPlace: 'false',

      establishmentTurnOffPrint: 'false',
      changeTurnOffPrint: 'false',

      establishmentTurnOffEid: 'false',
      changeTurnOffEid: 'false',

      establishmentTurnOffESignature: 'false',
      changeTurnOffESignature: 'false',

      temporaryInfoAboutDeliveryType: 'false',
    },
    loadedFromSaveForLater: false,
    saveError: null,
  },
  mutations: {
    SET_COUNTRIES(state, countries) {
      state.countries = countries;
    },
    SET_STREETS(state, streets) {
      state.streets = streets;
    },
    SET_CITIES(state, cities) {
      state.cities = cities;
    },
    SET_CONTACT_PLACES(state, contactPlaces) {
      state.contactPlaces = contactPlaces;
    },
    ADD_ATTACHMENTS(state, attachments) {
      state.attachments = [...state.attachments, ...attachments];
    },
    REMOVE_ATTACHMENT(state, index) {
      state.attachments.splice(index, 1);
    },
    REMOVE_PERSON_ATTACHMENTS(state, personIndex) {
      state.attachments = state.attachments.filter((attachment) => attachment.personIndex !== personIndex);
    },
    SET_E_TRANSACTION_CREATED(state, created) {
      state.eTransactionCreated = created;
    },
    SET_E_SIGNATURE_ATTEMPTS(state, attemptNo) {
      state.eSignatureAttempts = attemptNo;
    },
    SET_EID_ATTEMPTS(state, attemptNo) {
      state.eIDAttempts = attemptNo;
    },
    SET_APP_CONFIGURATION(state, configuration) {
      state.appConfiguration = configuration;
    },
    SET_LOADED_FROM_SAVE_FOR_LATER(state, isLoaded) {
      state.loadedFromSaveForLater = isLoaded;
    },
  },
  actions: {
    async getContactPlaces({ commit }) {
      const res = await axios.get('/app/contactPlaces.json');
      commit('SET_CONTACT_PLACES', res.data.map((place) => ({
        ...place,
        name$: place.id,
        label: `${place.city}, ${place.address}`,
        number: place.number !== '' ? place.number : undefined,
      })));
    },
  },
  getters: {
    getAttachments(state) { return state.attachments; },
    getSlovakia(state) { return state.countries.find((country) => country.value === COUNTRY_CODE_FOR_SLOVAKIA); },
    getUkraine(state) { return state.countries.find((country) => country.value === COUNTRY_CODE_FOR_UKRAINE); },
  },
});
